// extracted by mini-css-extract-plugin
export var extraMargin = "MapSection-module--extraMargin--f7481";
export var sectionContainer = "MapSection-module--sectionContainer--7a119";